// @flow

import { trackLink, trackImpression } from 'lib/analytics/fpti'

export const CONTACT_CONFIDENCE_PAGE_GROUP = 'main:p2p:contactConfidence'
export const CONTACT_CONFIDENCE_PAGE_NAME = 'main:p2p:contactConfidence::'

/**
 * Get contact confidence analytics FPTI data from recipient data
 * @param {Object} options
 * @param {boolean} options.isUnilateral - whether recipient is unilateral or not
 * @param {boolean} options.hasNetworkId - whether recipient has PayPal.me public network identity or not
 * @param {boolean} options.isRestricted - whether recipient is restricted from receiving payments or not
 * @param {boolean} options.isPhone - whether recipient is primarily a phone number or not
 * @param {boolean} options.isContact - whether recipient was selected from a contact or not
 */
export function getContactConfidenceAnalyticsData({
  isUnilateral,
  hasNetworkId,
  isRestricted,
  isPhone,
  isContact,
}: {
  isUnilateral: boolean,
  hasNetworkId: boolean,
  isRestricted: boolean,
  isPhone: boolean,
  isContact: boolean,
} = {}) {
  let pageVariant
  if (isUnilateral) {
    pageVariant = 'unilateral'
  } else if (hasNetworkId) {
    pageVariant = 'ppme_member'
  } else {
    pageVariant = 'ppmember'
  }

  return {
    page_variant: `Version_${pageVariant}`,
    recipient_ppmember_y_n: (!isUnilateral).toString(),
    recipient_ppme_member_y_n: Boolean(hasNetworkId).toString(),
    recipient_restricted_account_y_n: Boolean(isRestricted).toString(),
    recipient_phone_y_n: Boolean(isPhone).toString(),
    recipient_contact_y_n: Boolean(isContact).toString(),
  }
}

/**
 * Track contact confidence overpanel impression via FPTI analytics
 * @param {Object} data - FPTI data to track with the impression
 */
export function trackContactConfidenceImpression(data: Object) {
  trackImpression(
    CONTACT_CONFIDENCE_PAGE_GROUP,
    CONTACT_CONFIDENCE_PAGE_NAME,
    data
  )
}

/**
 * Track contact confidence cancel button click on overpanel via FPTI analytics
 */
export function trackContactConfidenceCancel() {
  trackLink(
    'cancel',
    CONTACT_CONFIDENCE_PAGE_GROUP,
    CONTACT_CONFIDENCE_PAGE_NAME,
    'link',
    {}
  )
}

/**
 * Track contact confidence primary submit button via FPTI analytics
 */
export function trackContactConfidenceSubmit() {
  trackLink(
    'submit',
    CONTACT_CONFIDENCE_PAGE_GROUP,
    CONTACT_CONFIDENCE_PAGE_NAME,
    'link',
    {}
  )
}
